<!--面板组件-->

<template>
  <div>
    <div class="overlay"></div>
    <div class="lightbox">
      <div class="dia_head">
        <div class="close_btn" @click="doClose()">
          <img src="@/assets/pc/icon-close.svg" alt="" />
        </div>
      </div>
      <div class="content_box">
        <p class="b_title">Merchant Services Hotline</p>
        <p class="s_title">Metro Manila</p>
        <p class="hotline">(02) 8702-6900 (PLDT)</p>
        <p class="hotline">(02) 7909-6900 (Globe)</p>
        <p class="s_title">Outside Metro Manila</p>
        <p class="hotline">1-800-10-8702-6900 (PLDT)</p>
        <p class="hotline">1-800-8-7909-6900 (Globe)</p>
        <p class="b_title mar_top ">Merchant Services Email</p>
        <p class="hotline">merchantsvcs@bdo.com.ph</p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "HotLinePop",
  components: {},
  data() {
    return {};
  },
  props: ["needDisagree", "btn_name"],
  methods: {
    doClose() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.46);
}
.lightbox {
  background: #ffffff;
  border-radius: 10px;
  width: 360px;
  height: 372px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  padding: 16.11px 14.5px 40px 32px;
  .dia_head {
    height: 15.78px;
    width: 100%;
    text-align: right;
    .close_btn {
      cursor: pointer;
    }
  }
  .dia_title {
    font-size: 20px;
    font-weight: 600;
    width: 100%;
    height: 27px;
    margin-bottom: 14px;
  }
  .content_box{
    text-align: left;
  }
  .b_title{
    color: #2E2E2E;
    font-size:20px ;
    font-weight: 700;
    // margin-bottom: ;
  }
  .s_title{
    color: #2E2E2E;
    font-size:16px ;
    font-weight: 600;
    margin-top: 16px;
  }
  .hotline{
    font-size: 16px;
    margin-top: 8px;
    color: #0072D8;
  }
  .mar_top{
    margin-top: 32px;
  }
  
}
</style>
